import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PoliticaPrivacidadPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <Navbar />
      <main className="pt-36 lg:pt-44 pb-24 lg:pb-32 px-8 md:px-12 lg:px-[8%]">
        <div className="max-w-4xl mx-auto relative">
          <span
            className="absolute -top-4 right-0 text-[140px] lg:text-[180px] font-extrabold text-[#E8DED2]/[0.12] leading-none tracking-[-0.05em] select-none pointer-events-none"
            aria-hidden="true"
          >
            PP
          </span>

          <p className="text-[10px] tracking-[0.35em] uppercase text-[#A39B92] font-medium mb-6">
            LEGAL
          </p>
          <h1 className="text-[clamp(2.5rem,5vw,4rem)] font-bold text-[#111111] leading-tight tracking-[-0.02em] mb-3">
            Política de Privacidad
          </h1>
          <div className="w-14 h-[2px] bg-[#D4B896] mb-16"></div>

          <div className="space-y-14 relative z-10">
            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Responsable del tratamiento
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                <strong>Responsable del tratamiento:</strong>
              </p>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-3">
                Proyecto LunaFinds (personaje digital)<br />
                Correo de contacto: <a href="mailto:lunafinds.es@gmail.com" className="text-[#D4B896] hover:underline">lunafinds.es@gmail.com</a><br />
                Sitio web: lunafinds.co
              </p>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-4">
                Dado que LunaFinds es un proyecto digital experimental bajo un personaje ficticio de IA, no existe titular físico ni jurídico formal. Para cualquier solicitud relacionada con tus datos, contacta al correo indicado arriba.
              </p>
            </div>

            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Finalidad del tratamiento
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                Gestionar las suscripciones al boletín informativo y responder a
                consultas enviadas a través del formulario de contacto.
              </p>
            </div>

            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Base legal
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                El consentimiento del usuario al facilitar sus datos.
              </p>
            </div>

            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Conservación de datos
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                Los datos se conservarán mientras el usuario no solicite su
                supresión.
              </p>
            </div>

            <div>
              <h2 className="text-[22px] lg:text-[26px] font-bold text-[#111111] mb-3 tracking-[-0.01em]">
                Derechos del usuario
              </h2>
              <div className="w-8 h-[1px] bg-[#E7CFCF] mb-4"></div>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
                El usuario puede ejercer sus derechos de acceso, rectificación,
                supresión y limitación enviando una solicitud al correo
                electrónico indicado.
              </p>
              <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-4">
                Este sitio no cede datos a terceros salvo obligación legal.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
